
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import { LanguageSwitch } from "./LanguageSwitch";
import { Menu, ChevronDown } from "lucide-react";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function Navbar() {
  const { t } = useLanguage();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  
  // Determine if we're on a 2025 page
  const is2025 = location.pathname.startsWith('/2025');
  const currentEdition = is2025 ? '2025' : '2026';

  return (
    <nav className="fixed top-0 w-full bg-white/80 backdrop-blur-md z-50 border-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link to={is2025 ? "/2025" : "/"}>
              <img 
                src="/lovable-uploads/iscae_nouakchott_logo.jpg"
                alt="ISCAE"
                className="h-16 w-auto"
              />
            </Link>
          </div>
          
          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <LanguageSwitch />
            <Button 
              variant="ghost" 
              size="icon"
              className="ml-2"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <Menu className="h-6 w-6" />
            </Button>
          </div>

          {/* Desktop menu */}
          <div className="hidden md:flex items-center space-x-4">
            {/* Edition Dropdown */}
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="outline" className="flex items-center gap-1">
                  {currentEdition === '2025' ? t('nav.edition2025') : t('nav.edition2026')}
                  <ChevronDown className="h-4 w-4" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent>
                <DropdownMenuItem asChild>
                  <Link to="/" className="w-full cursor-pointer">
                    {t('nav.edition2026')}
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <Link to="/2025" className="w-full cursor-pointer">
                    {t('nav.edition2025')}
                  </Link>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>

            <Button variant="ghost" asChild>
              <Link to={is2025 ? "/2025" : "/"}>{t('nav.home')}</Link>
            </Button>
            <Button variant="ghost" asChild>
              <Link to={is2025 ? "/2025/schedule" : "/schedule"}>{t('nav.schedule')}</Link>
            </Button>
            <LanguageSwitch />
          </div>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {/* Edition selector for mobile */}
              <div className="px-3 py-2 text-sm font-medium text-gray-500">
                {currentEdition === '2025' ? t('nav.edition2025') : t('nav.edition2026')}
              </div>
              <Button variant="ghost" className="w-full justify-start" asChild>
                <Link to="/" onClick={() => setIsMenuOpen(false)}>
                  {t('nav.edition2026')}
                </Link>
              </Button>
              <Button variant="ghost" className="w-full justify-start" asChild>
                <Link to="/2025" onClick={() => setIsMenuOpen(false)}>
                  {t('nav.edition2025')}
                </Link>
              </Button>
              <div className="border-t my-2" />
              <Button variant="ghost" className="w-full justify-start" asChild>
                <Link to={is2025 ? "/2025" : "/"} onClick={() => setIsMenuOpen(false)}>
                  {t('nav.home')}
                </Link>
              </Button>
              <Button variant="ghost" className="w-full justify-start" asChild>
                <Link to={is2025 ? "/2025/schedule" : "/schedule"} onClick={() => setIsMenuOpen(false)}>
                  {t('nav.schedule')}
                </Link>
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
